import { render } from "./areaTeaWorkAgeSubjectEchart.vue?vue&type=template&id=0df857fe&scoped=true"
import script from "./areaTeaWorkAgeSubjectEchart.vue?vue&type=script&lang=js"
export * from "./areaTeaWorkAgeSubjectEchart.vue?vue&type=script&lang=js"

import "./areaTeaWorkAgeSubjectEchart.vue?vue&type=style&index=0&id=0df857fe&scoped=true&lang=scss"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0df857fe"]])

export default __exports__